import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const OurValues = () => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div
      className={`${
        theme === "dark" ? "bg-white" : "bg-black"
      } flex flex-col mx-auto items-center w-full px-4 sm:px-20 justify-center py-10 sm:py-20 transition-all duration-500`}
    >
      <div
        className={`${
          theme === "dark"
            ? "bg-primary border-primary"
            : "bg-[#2A2A2A] border-secondary"
        } max-w-screen-2xl mx-auto flex flex-col items-center py-10 px-5 sm:px-20 rounded-3xl w-full relative group overflow-hidden transition-all duration-500 border`}
      >
        <h2
          className="text-3xl sm:text-5xl font-extrabold font-montserrat text-white text-center mb-8"
        >
          Our Values
        </h2>
        <p
          className="text-lg sm:text-xl mb-6 text-center text-white"
        >
          We strive to create a culture that fosters a humble, creative and
          inspiring workspace.
        </p>

        <p
          className="text-lg sm:text-xl mb-10 text-white text-center"
        >
          We strongly believe in doing our work with honesty, creativity, and a people-first approach. For us, it’s not just about delivering a service but also about building real partnerships. We listen, understand, and bring fresh ideas to help businesses grow in a way that feels natural, action-driven, and true to their vision.
        </p>

        <div className="size-[400px] bg-white p-14 rounded-full absolute bottom-6 left-6 bg-opacity-5 group-hover:scale-110 transition-all duration-300">
          <div className="size-full bg-white p-14 rounded-full bg-opacity-5 group-hover:scale-110 transition-all duration-300 delay-100">
            <div className="size-full bg-white rounded-full bg-opacity-5 group-hover:scale-110 transition-all duration-300 delay-300 flex items-center justify-center"></div>
          </div>
        </div>
        <svg
          width="1444"
          height="1292"
          viewBox="0 0 1444 1292"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute opacity-40 top-40 sm:-top-10 h-full sm:h-auto sm:w-full"
        >
          <g filter="url(#filter0_f_3562_1617)">
            <ellipse cx="722" cy="646" rx="643" ry="393" fill="#8D19DA" />
          </g>
          <defs>
            <filter
              id="filter0_f_3562_1617"
              x="-173.6"
              y="0.399994"
              width="1791.2"
              height="1291.2"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="126.3"
                result="effect1_foregroundBlur_3562_1617"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default OurValues;
